import types from './types'
import getters from './getters'
import store from "@/store";
// 全局变量
const state = {
  userToken: window.sessionStorage.userToken || null,
  accessToken: window.sessionStorage.accessToken || null,
  userData: JSON.parse(window.sessionStorage.userData || '{}'),
  bpmnSid: window.sessionStorage.bpmnSid || '',
  theme: '',

  chooseDept:null,//部门树数据
  chooseDataScopeDept:null,//管辖部门树数据
  status: "add",
  userMenus: [],
  newUserMenus: [],
  defaultCheckedArray: [],
  studentChooseTree:null,//学生树数据
  personChargeData: [],
  hierarchyTree:null,//树数据

  dialogTitle: "新增节点",
  formData: {
    id: "",
    hieName: "",
    target: "",
    hasChildren: ""
  },
  dialogVisible: false,
  labelWidth: "100px",
  radioArray: [{value: 0, text: "否"}, {value: 1, text: "是"}],
  lableArray: {
    id: "ID:",
    hieName: "名称:",
    target: "目标:",
    hasChildren: "是否有子元素:"
  },
  access_token: '',//token
  userInfo: {},//个人信息
  permissions: {},
  actives: null,
  activeTags: null,
  menuUrl: null,
  checkedArray: [],

  userMenus: [],
  roleTypeData: [
    { value: 0, label: "教师" },
    { value: 1, label: "学生" }
  ],
  userPermissionTypeDialog: {
    promptType: "",
    promptTittle: "新增",
    currentRowData: null,
    currentRoleId: ""
  },
  permissionDialog: false,
  roleFormDialog: {
    status: "",
    dialogTittle: "新增",
    currentRowData: null
  },
  roleFormData: {
    roleId: "",
    roleName: "",
    roleCode: "",
    roleType: "",
    roleDesc: "",
    defaultPage: "",
    defaultPageId: ""
  },
  defaultPageDialog: false,
  userTypes: [
    { label: "学生", value: "0" },
    { label: "教师", value: "1" },
    { label: "教职工", value: "2" }
  ],
  checkedItemArray: [],
  previewFileData:{data:null,state:false},
  tabsData:[],
  moduleList: [],  // 桌面信息
  unReadMsgCount:0
}

// 内部方法
const mutations = {
  [types.SET_USER_DTOKEN](state, value) {
    state.userToken = value
  },
  [types.SET_ACCESS_DTOKEN](state, value) {
    state.accessToken = value
  },
  [types.SET_USER_DATA](state, value) {
    state.userData = value
    window.sessionStorage.userData = JSON.stringify(value)
    return new Promise(resolve => {
      resolve()
    })
  },
  [types.LOGIN_OUT](state) {
    // window.sessionStorage.clear()
    localStorage.removeItem('userData')
    localStorage.removeItem('token')
    sessionStorage.removeItem('vuex')
    sessionStorage.removeItem('nz_access_token')
    sessionStorage.removeItem('setConfig')
    sessionStorage.removeItem('userData')

    document.cookie = null
    state.userToken = null
    state.accessToken = null
    state.userData = null
    return new Promise(resolve => {
      resolve()
    })
  },
  [types.CHANGE_THEME](state, value) {
    state.theme = value
  },

  setBpmnSid(state, value){
      state.bpmnSid = value;
      window.sessionStorage.loginBpmnTime = ''+Date.now();
      window.sessionStorage.bpmnSid=value;
  },

  setStatus(state, params) {
    state.status = params;
  },
  setTabsData(state, params) {
    state.tabsData = params;
  },
  setRoleFormDialogStatus(state, params) {  // 原setStatus,内诊移植过来重名了
    state.roleFormDialog.status = params;
  },
  setFormTitle(state) {
    if (state.status === "add") {
      state.dialogTitle = "新增节点";
    } else if (state.status === "edit") {
      state.dialogTitle = "编辑节点";
    }
  },
  setFormData(state, params) {
    const keys = Object.keys(state.formData);
    Object.keys(params.originData).forEach(key => {
      if (keys.includes(key)) {
        state.formData[key] = params.originData[key];
      }
    });
  },
  setDialog(state) {
    state.dialogVisible = !state.dialogVisible;
  },
  clearForm(state) {
    if (state.status === "add") {
      Object.keys(state.formData).forEach(key => {
        state.formData[key] = "";
      });
    }
  },
  SET_ACCESS_TOKEN: (state, access_token) => {
    state.access_token = access_token
  },
  SET_LOG_MSG(state, data) {
    state.userInfo = data
  },
  SET_PERMISSIONS: (state, permissions) => {
    const list = {};
    for (let i = 0; i < permissions.length; i++) {
      list[permissions[i]] = true
    }
    state.permissions = list
  },
  SET_CHOOSE_DEPT(state,deptData){//部门tree数据
    state.chooseDept = deptData
  },
  SET_STUDENT_TREE(state,deptData){ // 学生tree数据
    let a = function (data){
      data.forEach(e =>{
        e.expandId = e.id
        if(e.children.length>0){
          a(e.children)
        }
      })
    }
    a(deptData);
    state.studentChooseTree = deptData;
  },
  SET_NEW_MENU: (state, menu) => {
    state.newUserMenus = menu
  },
  SET_MENU: (state, menu) => {
    state.userMenus = menu
  },
  SET_ACTIVES(state, actives) {
    state.actives = actives;
  },
  SET_ACTIVE_TAG(state, data) {
    state.activeTags = data;
  },
  SET_MENU_URL(state, menuUrl) {
    state.menuUrl = menuUrl;
  },
  clearCheckedData(state) {
    state.checkedArrayObj = [];
  },
  clearChecked(state) {
    state.checkedArray = [];
  },
  clearDefaultChecked(state) {
    state.defaultCheckedArray = [];
    state.checkedArray = []
  },

  setDialogVisible(state, params) {
    state.dialogVisible = params;
  },
  setPermissionDialog(state, params) {
    state.permissionDialog = params;
  },
  setCurrentRowData(state, params) {
    state.roleFormDialog.currentRowData = params;
  },
  setRoleFormData(state, params) {
    const keys = Object.keys(state.roleFormData);
    Object.keys(params).forEach(key => {
      if (key == "defaultPage") {
        state.roleFormData["defaultPageId"] = Number(
            params["defaultPage"]
        );
        store.getters.userMenus.forEach((item, index) => {
          if (item.children.length > 0) {
            item.children.forEach((value, key) => {
              if (
                value.id == state.roleFormData.defaultPageId
              ) {
                state.roleFormData["defaultPage"] =
                  value.name;
                return;
              }
            });
          }
        });
      } else {
        if (
          keys.includes(key) &&
          !["defaultPageId", "defaultPage"].includes(key)
        ) {
          state.roleFormData[key] = params[key];
        }
      }
    });
  },
  setDialogTittle(state, params) {
    state.roleFormDialog.dialogTittle = params;
  },
  setPromptType(state, params) {
    state.userPermissionTypeDialog.promptType = params;
  },
  setCurrentRoleId(state, params) {
    state.userPermissionTypeDialog.currentRoleId = params;
  },
  setPromptTittle(state, params) {
    state.userPermissionTypeDialog.promptTittle = params;
  },
  setAddRoleFormData(state,param) {
    // state.roleFormData.roleType=param;
    state.roleFormData= {
      roleId: "",
      roleName: "",
      roleCode: "",
      roleType: param,
      roleDesc: "",
      defaultPage: "",
      defaultPageId: ""
    }
  },
  setDefaultPageDialog(state, params) {
    state.defaultPageDialog = params;
  },
  setDefaultPage(state, params) {
    const { name, id } = params;
    state.roleFormData.defaultPageId = id;
    state.roleFormData.defaultPage = name;
    state.defaultPageDialog = false;
  },
  setDefaultChecked(state, params) {
    const newArr = params.map(item => {
      return Number(item);
      // return item;
    });
    state.defaultCheckedArray = newArr;
    state.checkedArray = newArr;
  },
  clearCheckedItem(state) {
    state.checkedItemArray = [];
  },
  deleteCheckedItem(state, params) {
    var index = state.checkedItemArray.findIndex(e => e.id == params.id);
    state.checkedItemArray.splice(index, 1);
  },
  setPreviewFileData(state, params) {
    state.previewFileData = params;
  },
  setModuleList(state, data){
    state.moduleList = data;
  },
    setUnreadMsgCount(state, unreadCount){
        state.unReadMsgCount = unreadCount;
    },
}

export default {
  state,
  mutations,
  getters
}
